export const CHART_TYPES_ENUM = {
  BAR: 'bar',
  LINE: 'line',
  CIRCLE: 'circle',
};
